import { clearEmails, setEmails } from "../../../store/actions/emailActions";
import { authLogout } from "../../../store/actions/authActions";
import { clearMessage, setMessage } from "../../../store/actions/dialogActions";
import { setNotifications } from "../../../store/actions/notificationActions";
import API from "../../../store/api";

export const getEmails = (bearerAuth) => {
  return async dispatch => {

    dispatch(setMessage({ type: 'LOAD' }))

    API.get(`/api/portal/email/recent`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .ok(res => res.status === 200 || res.status === 401)
      .then((response) => {
        if (response.status === 200) {
          dispatch(clearMessage)
          dispatch(setEmails(response.body))
        } else if (response.status === 401) {
          dispatch(clearEmails);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          }
        }
        dispatch(setMessage({
          title: 'Send Email Failed',
          message: message,
          type: 'ERR',
        }))
      })
  }
}